
import { useNotifications } from '../hooks/useNotifications';
import NotificationDropdown from './NotificationDropdown';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useState, useRef, useEffect, useMemo } from 'react';
dayjs.extend(relativeTime);

export default function NotificationBell() {
  const notificationOptions = useMemo(() => ({
    page: 1,
    pageSize: 10,
    read: false,
  }), []); 
  const { data, refetch } = useNotifications(notificationOptions);
  const unreadCount = data?.notifications?.filter(n => !n.read).length;
  const [open, setOpen] = useState(false);
  const bellRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClick(e) {
      if (bellRef.current && !bellRef.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="relative" ref={bellRef}>
      <button
        className={`relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-blue-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300`}
        aria-label="Notifications"
        onClick={() => {
          refetch(); // Fetch notifications when user clicks
          setOpen((v) => !v);
        }}
      >
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5 py-0.5 shadow-lg animate-bounce" style={{ display: unreadCount ? 'block' : 'none' }}>{unreadCount}</span>
        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="text-blue-600">
          <path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6V9a6 6 0 1 0-12 0v7l-2 2v1h16v-1l-2-2z" />
        </svg>
      </button>
      <NotificationDropdown open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
